angular.module('dentalLinksDirectives')
    .directive('statusSelector', [function () {
        return {
            restrict: 'E',
            scope: {
                referral: "="
            },
            templateUrl: 'partials/directives/referral_status_selector.html',
            controller: 'StatusSelectorController'
        }
    }]);